
export const styleText = (text) => {
  // Handle tables
  let formattedText = text;

  const shouldBulletize = (inputText) => {
    if (!inputText) return false;
    if (inputText.includes('<ul>') || inputText.includes('<ol>')) return false;
    if (inputText.includes('\n')) return false;
    if (inputText.includes('|') && inputText.includes('\n')) return false;
    const sentences = inputText.match(/[^.!?]+[.!?]+|[^.!?]+$/g);
    return sentences && sentences.length >= 3;
  };

  if (shouldBulletize(formattedText)) {
    const sentences = formattedText
      .match(/[^.!?]+[.!?]+|[^.!?]+$/g)
      .map(sentence => sentence.trim())
      .filter(Boolean);

    const intro = sentences.shift();
    const bullets = sentences.map(sentence => sentence.replace(/^(Additionally,|Also,|And,)\s*/i, ''));

    formattedText = `<p>${intro}</p><ul>${bullets.map(sentence => `<li>${sentence}</li>`).join('')}</ul>`;
  }

  if (text.includes('|') && text.includes('\n')) {
    const lines = text.split('\n');
    let inTable = false;
    let tableHTML = '<div class="nova-chat-table-container"><table class="nova-chat-table">';
    let processedLines = [];

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].trim();

      if (line.includes('|')) {
        if (!inTable) {
          inTable = true;
          tableHTML = '<div class="nova-chat-table-container"><table class="nova-chat-table">';
        }

        const cells = line.split('|').map(cell => cell.trim()).filter(cell => cell);

        if (line.includes('---')) {
          continue;
        }

        tableHTML += '<tr>';
        cells.forEach(cell => {
          if (i === 0 || (i === 2 && lines[1].includes('---'))) {
            tableHTML += `<th>${cell}</th>`;
          } else {
            tableHTML += `<td>${cell}</td>`;
          }
        });
        tableHTML += '</tr>';
      } else {
        if (inTable) {
          tableHTML += '</table></div>';
          processedLines.push(tableHTML);
          inTable = false;
        }
        processedLines.push(line);
      }
    }

    if (inTable) {
      tableHTML += '</table></div>';
      processedLines.push(tableHTML);
    }

    formattedText = processedLines.join('\n');
  }

  // Continue with other formatting
  return formattedText
    .replace(/#### (.*?)(\n|$)/g, "<h4>$1</h4>")
    .replace(/### (.*?)(\n|$)/g, "<h3>$1</h3>")
    .replace(/## (.*?)(\n|$)/g, "<h2>$1</h2>")
    .replace(/# (.*?)(\n|$)/g, "<h1>$1</h1>")
    .replace(/\*\*(.*?)\*\*/g, "<b>$1</b>")
    .replace(/\*(.*?)\*/g, "<i>$1</i>")
    .replace(/~~(.*?)~~/g, "<s>$1</s>")
    .replace(/\n/g, "<br>");
};